module.exports = __webpack_public_path__ + "static/media/camion.b92072cc.svg";